import { AccrualDateMode } from '@root/query'

export const DEFAULT_ACCRUAL_DATE_MODE: AccrualDateMode = 'previous_month_end'

export const ACCRUAL_DATE_OPTIONS: Array<{ value: AccrualDateMode; labelKey: string }> = [
  { value: 'invoice_date', labelKey: 'accrualDateInvoice' },
  { value: 'previous_month_end', labelKey: 'accrualDatePreviousMonth' },
  { value: 'two_months_end', labelKey: 'accrualDateTwoMonths' },
  { value: 'delivery_date', labelKey: 'accrualDateDelivery' }
]

export const isPurchaseInvoiceSource = (
  hasAccrual: boolean,
  accrualDateMode: AccrualDateMode | null | undefined
): boolean => hasAccrual && Boolean(accrualDateMode)

export const accrualDateLabelKey = (mode: AccrualDateMode | null | undefined): string | undefined =>
  ACCRUAL_DATE_OPTIONS.find(option => option.value === mode)?.labelKey
